import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import * as L from 'leaflet';

/**
 * O Leaflet é carregado 3 vezes neste projeto (CDN em index.html, script
 * global em angular.json e este `import` usado em todo o código do app).
 * São 3 instâncias distintas em memória, e cada uma reatribui `window.L`
 * como último passo da sua própria inicialização — a última a rodar
 * "vence". Plugins como leaflet-geoman, leaflet.browser.print e
 * L.cascadeButtons não importam o Leaflet: eles só corrigem/leem a
 * global `window.L` no momento em que o próprio plugin é carregado.
 *
 * Sem isto, a ordem de carregamento (script global vs. chunk lazy do
 * Angular) decide, de forma não-determinística, se esses plugins acabam
 * corrigindo a mesma instância que o resto do app usa (`import * as L
 * from 'leaflet'`) ou uma instância órfã que é sobrescrita depois.
 * Fixando `window.L` para esta instância aqui, antes de qualquer módulo
 * lazy (onde esses plugins são importados) ser carregado, garante que
 * todos eles sempre corrijam a mesma instância usada em todo o app.
 */
(window as unknown as { L: typeof L }).L = L;

if (environment.production) {
    enableProdMode();
    window.console.log = () => {};
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.error(err));
